import React from "react";
import type { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { SurveyFormScreen } from "./pages/form/survey-form.screen";
import { MenuScreen } from "./pages/menu";
import { PendingFollowUpScreen } from "./pages/pending-follow-up";
import { CandidateDataFormScreen } from "./pages/candidate-data-form/candidate-data-form.screen";
import { JoinDoneScreen } from "./pages/candidate-data-form/join-done.screen";
import { JoinExpiredScreen } from "./pages/candidate-data-form/join-expired.screen";
import { InvitationCancelledScreen } from "./pages/candidate-data-form/invitation-cancelled.screen";
import { CourseMenuScreen } from "./pages/course-menu-screen/course-menu-screen";
import { CourseLessonScreen } from "./pages/course-menu-screen/screens/course-lesson-screen/course-lesson-screen";
import { CourseQuizScreen } from "./pages/course-menu-screen/screens/course-quiz-screen/course-quiz-screen";
import { ExamMenuScreen } from "./pages/exam-menu-screen/exam-menu-screen";
import { ExamRegistryScreen } from "./pages/exam-menu-screen/screens/exam-registry-screen/exam-registry-screen";
import { CourseQuizFeedbackScreen } from "./pages/course-menu-screen/screens/course-quiz-screen/quiz-feedback-screen";
import { ExamFeedbackScreen } from "./pages/exam-menu-screen/screens/exam-registry-screen/exam-feedback-screen";
import { CreateNPAScreen } from "./pages/form/screan-npa.screen";
import { ReassessPage } from "./pages/reassess/reassess.screen";
import { ExamRegistrationPLAI } from "./pages/exam-registration/exam-registration";
import { ApplicationDetailScreen } from "./pages/application-detail-screen/application-detail.screen";

export const routesOnboarding: RouteObject[] = [
  { path: "menu", index: true, element: <MenuScreen /> },
  {
    path: "form",
    element: <Outlet />,
    children: [
      { path: "", index: true, element: <SurveyFormScreen /> },
      { path: "create-npa", element: <CreateNPAScreen /> },
    ],
  },
  { path: "application-detail", element: <ApplicationDetailScreen /> },
  {
    path: "courses",
    element: <Outlet />,
    children: [
      { path: "", index: true, element: <CourseMenuScreen /> },
      { path: "lesson", element: <CourseLessonScreen /> },
      { path: "quiz/:quizId", element: <CourseQuizScreen /> },
      { path: "quiz/:quizId/feedback", element: <CourseQuizFeedbackScreen /> },
    ],
  },
  {
    path: "exams",
    element: <Outlet />,
    children: [
      { path: "", index: true, element: <ExamMenuScreen /> },
      { path: "registry/:examId", element: <ExamRegistryScreen /> },
      { path: "registry/:examId/feedback", element: <ExamFeedbackScreen /> },
      { path: "registry-plai", element: <ExamRegistrationPLAI /> },
    ],
  },
  // { path: "courses", element: <CourseMenuScreen /> },
  { path: "follow-up", element: <PendingFollowUpScreen /> },
  { path: "reassess", element: <ReassessPage /> },
  { path: "join-now", element: <CandidateDataFormScreen /> },
  { path: "join-done", element: <JoinDoneScreen /> },
  { path: "join-expired", element: <JoinExpiredScreen /> },
  { path: "invitation-cancelled", element: <InvitationCancelledScreen /> },
];
